import { Component, Inject, LOCALE_ID, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RestApiService } from '../../shared/services/rest-api.service';
import { ToolbarService } from '../../shared/services/toolbar.service';
import { DxFormComponent } from 'devextreme-angular';

import { confirm } from 'devextreme/ui/dialog';
import { Clock } from '../../shared/models/clock';
import { APIKey, MapMarker } from '../../shared/models/map-marker';
import { Subject, takeUntil } from 'rxjs';
import { HoursOption } from '../../shared/models/hours-option';
import { WorkerAndToolService } from '../../shared/services/worker-and-tool.service';
import { formatDate } from '@angular/common';



import Map from 'ol/Map';
import View from 'ol/View';
//import TileLayer from 'ol/layer/Tile';
//import OSM from 'ol/source/OSM';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import Group from 'ol/layer/Group';
import Overlay from 'ol/Overlay';
import { Style, Icon } from 'ol/style';
import { fromLonLat } from 'ol/proj';

import XYZ from 'ol/source/XYZ';
import { apply } from 'ol-mapbox-style';


interface MarkersInfo {
  lat: number;
  lng: number;
  descr: string;
}



@Component({
    selector: 'app-clock-detail',
    templateUrl: './clock-detail.component.html',
    styleUrls: ['./clock-detail.component.scss'],
    standalone: false
})
export class ClockDetailComponent {

  option: HoursOption | undefined;

  clock!: Clock;
  clockId: number | null;

  markers: MapMarker[] = [];

  apiKey: APIKey = {
    azure: "ChfbRnQ9Q26640aewm0WMyuswqe74umqdOTQ2LxSQhhd7PEe5hN4JQQJ99BJAC5RqLJ7BGfpAAAgAZMP4egU"
  };

  private unsubscribe: Subject<void> = new Subject<void>();


  map!: Map;
  private vectorSource!: VectorSource;
  private overlay!: Overlay;
  public locationData: MarkersInfo[] = [];

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private service: WorkerAndToolService,
    private restApi: RestApiService,
    private toolbar: ToolbarService,
    private route: ActivatedRoute,
    private router: Router) {

    this.clockId = null;

    let tenantId = localStorage.getItem("tenantId");
    tenantId ??= "0";

    let dataRegistrazione = new Date();
    const offset = dataRegistrazione.getTimezoneOffset();
    dataRegistrazione = new Date(dataRegistrazione.getTime() - (offset * 60 * 1000))

    let user = localStorage.getItem("user");
    if (user == null) user = "   ";
    const workerNumber = user.substring(3);

    this.clock = {
      tenantID: +tenantId,
      deviceDate: dataRegistrazione,
      direction: "E",
      workerNumber: workerNumber
    }

  }

  ngOnInit() {
    this.toolbar.backClickedEvent.pipe(takeUntil(this.unsubscribe)).subscribe(() => this.Back());
    this.toolbar.deleteClickedEvent.pipe(takeUntil(this.unsubscribe)).subscribe(() => this.Delete());
    this.toolbar.editClickedEvent.pipe(takeUntil(this.unsubscribe)).subscribe(() => this.Edit());

    this.toolbar.BackVisibleChanged(true);
    this.toolbar.SaveVisibleChanged(false);
    this.toolbar.ForwardVisibleChanged(false);
    this.toolbar.CancelVisibleChanged(false);
    this.toolbar.PlusVisibleChanged(false);
    this.toolbar.EditVisibleChanged(false);
    this.toolbar.CopyVisibleChanged(false);
    this.toolbar.MenuVisibleChanged(false);
    this.toolbar.DeleteVisibleChanged(true);


    this.vectorSource = new VectorSource();


    this.service.getHoursOptionObservable().pipe(takeUntil(this.unsubscribe)).subscribe(val =>
    {
      this.option = val;

      if (this.option?.editClock) {
        this.toolbar.EditVisibleChanged(true);
        this.toolbar.CopyVisibleChanged(false);
      }
      else {
        this.toolbar.EditVisibleChanged(false);
        this.toolbar.CopyVisibleChanged(false);
      }

    });

   

    const regId = this.route.snapshot.paramMap.get('id');
    if (regId != null) this.clockId = +regId;

    if (this.clockId != null) {
      this.toolbar.TitleChanged("Timbratura");

      if (this.clockId > 0) {
        this.restApi.getClock(this.clockId).pipe(takeUntil(this.unsubscribe)).subscribe(
          (clk) => {
            this.clock = clk;

            if (clk.latitudine && clk.longitudine) {
              let clockDate = clk.gpsDate;
              if (!clockDate) clockDate = clk.deviceDate;
              let direction = clk.direction;
              if (!direction) direction = '';

              //--- old map --//
              const clkMarker = new MapMarker(clk.latitudine, clk.longitudine, 'Timbratura (' + direction + ') ' + formatDate(clockDate, 'HH:mm', this.locale));
              this.markers.push(clkMarker);
              //-----//



              this.locationData.push({ lat: clk.latitudine, lng: clk.longitudine, descr: 'Timbratura (' + direction + ') ' + formatDate(clockDate, 'HH:mm', this.locale) })

              const feat = new Feature({
                geometry: new Point(fromLonLat([clk.longitudine, clk.latitudine])),
                descr: 'Timbratura (' + direction + ') ' + formatDate(clockDate, 'HH:mm', this.locale)
              });
              feat.setStyle(
                new Style({
                  image: new Icon({
                    anchor: [0.5, 1],
                    crossOrigin: 'anonymous',
                    src: '/assets/clock-marker.png',
                  })
                })
              );
              this.vectorSource.addFeature(feat);


            }

            if (clk.latitudineCantiere && clk.longitudineCantiere && clk.descrizioneCantiere) {

              //--- old map --//
              const clkCantiereMarker = new MapMarker(clk.latitudineCantiere, clk.longitudineCantiere, clk.descrizioneCantiere);
              clkCantiereMarker.iconSrc = '/assets/construction-marker.png';
              this.markers.push(clkCantiereMarker);
              //-------//

              const feat = new Feature({
                geometry: new Point(fromLonLat([clk.longitudineCantiere, clk.latitudineCantiere])),
                descr: clk.descrizioneCantiere
              });
              feat.setStyle(
                new Style({
                  image: new Icon({
                    anchor: [0.5, 1],
                    crossOrigin: 'anonymous',
                    src: '/assets/construction-marker.png',
                  })
                })
              );
              this.vectorSource.addFeature(feat);

            }



            // popup overlay (cerca gli elementi nel template)
            const container = document.getElementById('popup') as HTMLElement;
            const content = document.getElementById('popup-content') as HTMLElement;
            const closer = document.getElementById('popup-closer') as HTMLElement;

            // per i messaggi popup 
            this.overlay = new Overlay({
              element: container!,
              autoPan: { animation: { duration: 250 } }
            });

            // chiudi popup
            if (closer) {
              closer.onclick = () => {
                this.overlay.setPosition(undefined);
                closer.blur();
                return false;
              };
            }

            const openfreemap = new Group();

            // crea la mappa
            this.map = new Map({
              target: 'ol-map',
              layers: [openfreemap],  //[baseLayer, vectorLayer],
              view: new View({
                center: fromLonLat([12.57, 44.06]), // valore temporaneo, verrà adattato
                zoom: 13,
                maxZoom: 22,
              }),
              overlays: [this.overlay]
            });

            // click su mappa: mostra popup se feature sotto il click
            this.map.on('singleclick', (evt) => {
              const feature = this.map.forEachFeatureAtPixel(evt.pixel, (f) => f);

              if (feature) {
                const geometry = feature.getGeometry();
                if (geometry && geometry.getType() === 'Point') {
                  //const coords = (feature.getGeometry() as Point).getCoordinates();
                  const coords = (geometry as Point).getCoordinates();
                  const descr = feature.get('descr') || 'Nessuna descrizione';
                  if (content) content.innerHTML = descr;
                  this.overlay.setPosition(coords);
                } else {
                  this.overlay.setPosition(undefined);
                }
              }
            });


            apply(this.map, 'https://tiles.openfreemap.org/styles/liberty')
              .then(() => {
                const vectorLayer = new VectorLayer({
                  source: this.vectorSource,
                  // non passare 'map' qui, aggiungilo con addLayer per essere sicuro
                });
                this.map.addLayer(vectorLayer);

                // fit automatico se ci sono marker
                if (this.vectorSource.getFeatures().length > 0) {
                  const extent = this.vectorSource.getExtent();

                  if (extent) {
                    this.map.getView().fit(extent!, { padding: [50, 50, 50, 50], maxZoom: 22, duration: 800 });
                  }
}
              })
              .catch(err => {
                console.warn('Errore apply map style:', err);
                // aggiungi comunque vector layer se apply fallisce
                const vectorLayer = new VectorLayer({ source: this.vectorSource });
                this.map.addLayer(vectorLayer);
              });





          }
        );        
      }
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  Back(): void {
    this.router.navigate(['/clocks']);
  }

  Edit(): void {
    this.router.navigate(['/clock', { id: this.clockId }]);
  }

  Delete(): void {
    const result = confirm("<i>Sei sicuro?</i><br>I dati inseriti andranno persi", "Conferma Cancellazione");

    result.then((dialogResult) => {
      if (dialogResult && this.clockId) {
        this.restApi.deleteClock(this.clockId).pipe(takeUntil(this.unsubscribe)).subscribe(() => this.router.navigate(['/clocks']));
      }
    });

  }
}
